import { ApButtonSecondary, ApButtonTab } from '@alixpartners/ui-components';
import React, { useState, useEffect } from 'react';
import { ContentDiv, FlexWrapper, NavDiv } from './SkuAnalysis.styles';
// import UploadData from './UploadData/UploadData';
import { SkuFileArchiveContextProvider } from 'contexts/SkuFileArchiveContext/SkuFileArchiveContextProvider';
import SegmentedData from './SegmentedData/SegmentedData';
import MultisourceSkuData from './MultisourceSkuData/MultisourceSkuData';
import { useLocation } from 'react-router-dom';
import { BackButtonWrapper } from '../CategoryWidget.styles';

const SkuAnalysis = ({ setCurrentContent }) => {
	const INITIAL_SUBNAV_CONFIG = [
		// {
		// 	id: 0,
		// 	name: 'upload',
		// 	label: 'Upload Data',
		// 	isActive: false,
		// 	component: UploadData,
		// },
		{
			id: 1,
			name: 'multisource-data',
			label: 'Master SKU Data',
			isActive: false,
			component: MultisourceSkuData,
		},
		{
			id: 2,
			name: 'seg-data',
			label: 'SKU Analysis',
			isActive: true,
			component: SegmentedData,
		},
	];

	const [subNav, setSubNav] = useState(INITIAL_SUBNAV_CONFIG);
	const location = useLocation();

	useEffect(
		() => {
			location.state?.isSegment && subNavHandler(2);
		},
		// eslint-disable-next-line
		[location.state?.isSegment]
	);
	useEffect(
		() => {
			location.state?.isMaster && subNavHandler(1);
		},
		// eslint-disable-next-line
		[location.state?.isMaster]
	);

	const subNavHandler = value => {
		setSubNav(prevState =>
			prevState.map(el => {
				if (el.id === value) {
					return { ...el, isActive: true };
				} else {
					return { ...el, isActive: false };
				}
			})
		);
	};
	return (
		<>
			<FlexWrapper>
				<NavDiv>
					{subNav.map(({ id, name, label, isActive }) => (
						<ApButtonTab
							key={id}
							name={name}
							isSelected={isActive}
							onClick={() => {
								subNavHandler(id);
							}}
							small
						>
							{label}
						</ApButtonTab>
					))}
				</NavDiv>
				<BackButtonWrapper>
					<ApButtonSecondary small onClick={() => setCurrentContent(0)}>
						Back
					</ApButtonSecondary>
				</BackButtonWrapper>
			</FlexWrapper>

			<SkuFileArchiveContextProvider>
				<ContentDiv>
					{subNav.map(({ id, isActive, component: Component }) => {
						return (
							isActive && (
								<Component key={id} setCurrentContent={setCurrentContent} />
							)
						);
					})}
				</ContentDiv>
			</SkuFileArchiveContextProvider>
		</>
	);
};

export default SkuAnalysis;
